import BaseApi from './BaseApi';

class AdminPhotoApi extends BaseApi {
  constructor() {
    super('admin/photos');
  }

  async update(photoId, params) {
    const request = await this.put(photoId, params);
    return (request) ? request.data.photo : request;
  }
}

export default new AdminPhotoApi();